// ─── Lazy NLP + OCR Imports (only loaded when needed) ───────────────────────
let _nlpEngine = null;
let _npuEngine = null;

async function _loadNlpEngine() {
    if (_nlpEngine) return _nlpEngine;
    _nlpEngine = await import('/js/nlp/nlpEngine.js').catch(() => null);
    return _nlpEngine;
}

async function _loadNpuEngine() {
    if (_npuEngine) return _npuEngine;
    _npuEngine = await import('/js/nlp/NpuLiteEngine.js').catch(() => null);
    return _npuEngine;
}

document.addEventListener("DOMContentLoaded", () => {
    // PDF Audit Report Export Listener
    const downloadReportBtn = document.getElementById('download-report-btn');
    if (downloadReportBtn) {
        downloadReportBtn.addEventListener('click', async () => {
            const reportMod = await import('/js/reportGenerator.js').catch(() => null);
            if (reportMod && reportMod.generatePdfReport) {
                reportMod.generatePdfReport(window._lastScanData, window._lastNlpResult);
            }
        });
    }

    const Inputs = {
        form: document.getElementById('ats-unified-form'),
        jd: document.getElementById('jd-input'),
        jdFile: document.getElementById('jd-file-input'),
        jdTabPaste: document.getElementById('jd-tab-paste'),
        jdTabUrl: document.getElementById('jd-tab-url'),
        jdTabUpload: document.getElementById('jd-tab-upload'),
        jdWrapperPaste: document.getElementById('jd-wrapper-paste'),
        jdWrapperUrl: document.getElementById('jd-wrapper-url'),
        jdWrapperUpload: document.getElementById('jd-wrapper-upload'),
        jdUrlInput: document.getElementById('jd-url-input'),
        jdUrlFetchBtn: document.getElementById('jd-url-fetch-btn'),
        jdUrlBtnText: document.getElementById('jd-url-btn-text'),
        jdDropzone: document.getElementById('jd-dropzone'),
        jdFileLabelStatus: document.getElementById('jd-file-label-status'),
        file: document.getElementById('cv-file-input'),
        text: document.getElementById('cv-text-input'),
        trigger: document.getElementById('submit-trigger'),
        error: document.getElementById('error-output'),
        errorText: document.getElementById('error-text'),
        results: document.getElementById('results-dashboard'),
        wrapperUpload: document.getElementById('wrapper-upload'),
        wrapperPaste: document.getElementById('wrapper-paste'),
        tabUpload: document.getElementById('tab-upload'),
        tabPaste: document.getElementById('tab-paste'),
        step1Check: document.getElementById('step1-check'),
        step2Check: document.getElementById('step2-check')
    };

    let selectedInputMode = 'upload';
    let jdInputMode = 'paste';
    let selectedAtsProfile = 'General';
    let isAnalyzing = false;
    const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;

    const TAB_3_ACTIVE = "w-1/3 py-1.5 text-xs font-bold text-indigo-700 bg-white shadow-sm rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400";
    const TAB_3_INACTIVE = "w-1/3 py-1.5 text-xs font-bold text-slate-500 hover:text-slate-700 rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400";

    const TAB_ACTIVE = "w-1/2 py-1.5 text-xs font-bold text-indigo-700 bg-white shadow-sm rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400";
    const TAB_INACTIVE = "w-1/2 py-1.5 text-xs font-bold text-slate-500 hover:text-slate-700 rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400";

    function refreshStepIndicators() {
        const jdFilled = jdInputMode === 'upload' ? !!(Inputs.jdFile && Inputs.jdFile.files[0]) : !!(Inputs.jd && Inputs.jd.value.trim());
        const cvFilled = selectedInputMode === 'upload' ? !!(Inputs.file && Inputs.file.files[0]) : !!(Inputs.text && Inputs.text.value.trim());
        if (Inputs.step1Check) Inputs.step1Check.classList.toggle('opacity-100', jdFilled);
        if (Inputs.step1Check) Inputs.step1Check.classList.toggle('opacity-0', !jdFilled);
        if (Inputs.step2Check) Inputs.step2Check.classList.toggle('opacity-100', cvFilled);
        if (Inputs.step2Check) Inputs.step2Check.classList.toggle('opacity-0', !cvFilled);
    }

    if (Inputs.jdTabPaste) {
        Inputs.jdTabPaste.addEventListener('click', () => {
            jdInputMode = 'paste';
            Inputs.jdTabPaste.className = TAB_3_ACTIVE;
            if (Inputs.jdTabUrl) Inputs.jdTabUrl.className = TAB_3_INACTIVE;
            Inputs.jdTabUpload.className = TAB_3_INACTIVE;
            requestAnimationFrame(() => {
                Inputs.jdWrapperPaste.classList.remove('hidden');
                if (Inputs.jdWrapperUrl) Inputs.jdWrapperUrl.classList.add('hidden');
                Inputs.jdWrapperUpload.classList.add('hidden');
                refreshStepIndicators();
            });
        });
    }

    if (Inputs.jdTabUrl) {
        Inputs.jdTabUrl.addEventListener('click', () => {
            jdInputMode = 'url';
            Inputs.jdTabUrl.className = TAB_3_ACTIVE;
            Inputs.jdTabPaste.className = TAB_3_INACTIVE;
            Inputs.jdTabUpload.className = TAB_3_INACTIVE;
            requestAnimationFrame(() => {
                Inputs.jdWrapperUrl.classList.remove('hidden');
                Inputs.jdWrapperPaste.classList.add('hidden');
                Inputs.jdWrapperUpload.classList.add('hidden');
                refreshStepIndicators();
            });
        });
    }

    if (Inputs.jdTabUpload) {
        Inputs.jdTabUpload.addEventListener('click', () => {
            jdInputMode = 'upload';
            Inputs.jdTabUpload.className = TAB_3_ACTIVE;
            Inputs.jdTabPaste.className = TAB_3_INACTIVE;
            if (Inputs.jdTabUrl) Inputs.jdTabUrl.className = TAB_3_INACTIVE;
            requestAnimationFrame(() => {
                Inputs.jdWrapperUpload.classList.remove('hidden');
                Inputs.jdWrapperPaste.classList.add('hidden');
                if (Inputs.jdWrapperUrl) Inputs.jdWrapperUrl.classList.add('hidden');
                refreshStepIndicators();
            });
        });
    }

    // Auto-Fetch Job Details from LinkedIn / URL
    if (Inputs.jdUrlFetchBtn) {
        Inputs.jdUrlFetchBtn.addEventListener('click', async () => {
            const urlVal = Inputs.jdUrlInput ? Inputs.jdUrlInput.value.trim() : '';
            if (!urlVal) return showError("Please enter a valid job URL.");

            if (Inputs.jdUrlBtnText) Inputs.jdUrlBtnText.textContent = "Fetching...";
            Inputs.jdUrlFetchBtn.disabled = true;

            try {
                const res = await fetch('/api/fetch-job-url', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ url: urlVal })
                });

                const data = await res.json();
                if (!res.ok || !data.success) {
                    throw new Error(data.error || "Failed to fetch job description.");
                }

                if (Inputs.jd) {
                    Inputs.jd.value = data.description;
                    updateWordCount(data.description, 'jd-word-counter');
                }
                
                // Switch back to text view so user can see imported content
                if (Inputs.jdTabPaste) Inputs.jdTabPaste.click();
                if (Inputs.error) Inputs.error.classList.add('hidden');

            } catch (err) {
                showError("Job Import Failed: " + err.message);
            } finally {
                if (Inputs.jdUrlBtnText) Inputs.jdUrlBtnText.textContent = "Import Job";
                Inputs.jdUrlFetchBtn.disabled = false;
            }
        });
    }

    if (Inputs.jdDropzone) {
        Inputs.jdDropzone.addEventListener('click', () => Inputs.jdFile.click());
        Inputs.jdDropzone.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); Inputs.jdFile.click(); }
        });
    }

    // ── Auto-Import: detect embedded job URL in pathname (usestandout pattern) ──
    // Supports: resumemetric.com/linkedin.com/jobs/view/12345
    //           resumemetric.com/linkedin.com/jobs/search-results/?currentJobId=12345
    //           resumemetric.com/indeed.com/viewjob?jk=abc123
    (function detectEmbeddedJobUrl() {
        const path = window.location.pathname;
        const search = window.location.search;
        const jobSitePatterns = [
            /^\/((?:[a-z0-9-]+\.)?linkedin\.com\/.+)/i,
            /^\/((?:[a-z0-9-]+\.)?xing\.com\/.+)/i,
            /^\/((?:[a-z0-9-]+\.)?indeed\.com\/.+)/i,
            /^\/((?:[a-z0-9-]+\.)?glassdoor\.com\/.+)/i
        ];

        let embeddedUrl = null;
        for (const pattern of jobSitePatterns) {
            const match = path.match(pattern);
            if (match) {
                embeddedUrl = 'https://' + match[1] + (search || '');
                break;
            }
        }

        // Also check if passed via query param
        if (!embeddedUrl && window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            const paramJob = urlParams.get('jobUrl');
            if (paramJob) embeddedUrl = paramJob;
        }

        if (!embeddedUrl) return;

        // If not on scanner page, forward to scanner
        if (!Inputs.form) {
            window.location.href = '/scanner/?jobUrl=' + encodeURIComponent(embeddedUrl);
            return;
        }

        // Update browser URL to /scanner/ (clean up the address bar)
        if (window.history && window.history.replaceState) {
            window.history.replaceState({}, document.title, '/scanner/');
        }

        // Switch to URL tab and populate
        if (Inputs.jdTabUrl) Inputs.jdTabUrl.click();
        if (Inputs.jdUrlInput) Inputs.jdUrlInput.value = embeddedUrl;

        // Auto-trigger fetch with a small delay to let UI settle
        setTimeout(() => {
            if (Inputs.jdUrlFetchBtn) Inputs.jdUrlFetchBtn.click();
        }, 300);
    })();

    // ── Auto-Import: detect resume payload from /templates editor ──
    (function detectTemplatePayload() {
        const payload = localStorage.getItem('resumemetric_scan_payload');
        if (payload && (window.location.search.includes('ref=template_editor') || payload.length > 50)) {
            setTimeout(() => {
                if (Inputs.tabPaste) Inputs.tabPaste.click();
                if (Inputs.text) {
                    Inputs.text.value = payload;
                    updateWordCount(payload, 'cv-word-counter');
                    refreshStepIndicators();
                }
                localStorage.removeItem('resumemetric_scan_payload');
                const form = document.getElementById('ats-unified-form');
                if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 200);
        }
    })();

    if (Inputs.jdFile) {
        Inputs.jdFile.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (!file) return;
            if (file.size > MAX_FILE_SIZE_BYTES) {
                showError(`File size (${(file.size / (1024 * 1024)).toFixed(2)}MB) exceeds 2MB limit.`);
                Inputs.jdFile.value = "";
                if (Inputs.jdFileLabelStatus) Inputs.jdFileLabelStatus.innerHTML = `Upload job description (<span class="text-rose-600 underline">Exceeds 2MB Limit</span>)`;
                return;
            }
            const validExts = ['.pdf', '.docx', '.txt'];
            if (!validExts.some(ext => file.name.toLowerCase().endsWith(ext))) {
                showError("Invalid format. Use PDF, DOCX, or TXT.");
                Inputs.jdFile.value = "";
                if (Inputs.jdFileLabelStatus) Inputs.jdFileLabelStatus.innerHTML = `Upload job description (<span class="text-rose-600 underline">Invalid File</span>)`;
            } else {
                if (Inputs.error) Inputs.error.classList.add('hidden');
                showFileCard('jd', file);
                if (Inputs.jdFileLabelStatus) Inputs.jdFileLabelStatus.innerHTML = `Loaded: <span class="text-indigo-600 font-bold">${file.name}</span>`;
            }
            refreshStepIndicators();
        });
    }

    if (Inputs.tabUpload) {
        Inputs.tabUpload.addEventListener('click', () => {
            selectedInputMode = 'upload';
            Inputs.tabUpload.className = TAB_ACTIVE;
            Inputs.tabPaste.className = TAB_INACTIVE;
            requestAnimationFrame(() => {
                Inputs.wrapperUpload.classList.remove('hidden');
                Inputs.wrapperPaste.classList.add('hidden');
                refreshStepIndicators();
            });
        });
    }
    if (Inputs.tabPaste) {
        Inputs.tabPaste.addEventListener('click', () => {
            selectedInputMode = 'paste';
            Inputs.tabPaste.className = TAB_ACTIVE;
            Inputs.tabUpload.className = TAB_INACTIVE;
            requestAnimationFrame(() => {
                Inputs.wrapperPaste.classList.remove('hidden');
                Inputs.wrapperUpload.classList.add('hidden');
                refreshStepIndicators();
            });
        });
    }

    if (Inputs.wrapperUpload) {
        Inputs.wrapperUpload.addEventListener('click', () => Inputs.file.click());
        Inputs.wrapperUpload.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); Inputs.file.click(); }
        });
    }
    if (Inputs.file) {
        Inputs.file.addEventListener('change', (e) => {
            const activeFile = e.target.files[0];
            if (activeFile) {
                if (activeFile.size > MAX_FILE_SIZE_BYTES) {
                    showError(`File size (${(activeFile.size / (1024 * 1024)).toFixed(2)}MB) exceeds the maximum allowed limit of 2MB.`);
                    Inputs.file.value = "";
                    return;
                }
                if (!activeFile.name.toLowerCase().endsWith('.docx') && activeFile.type !== 'application/pdf' && !activeFile.name.toLowerCase().endsWith('.pdf')) {
                    showError("Invalid format. Use PDF or DOCX strictly.");
                    Inputs.file.value = "";
                } else {
                    if (Inputs.error) Inputs.error.classList.add('hidden');
                    showFileCard('cv', activeFile);
                }
            }
            refreshStepIndicators();
        });
    }

    function formatBytes(bytes) {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    }

    function showFileCard(prefix, file) {
        const dropzone = document.getElementById(prefix === 'cv' ? 'wrapper-upload' : 'jd-dropzone');
        const card = document.getElementById(prefix + '-file-card');
        const nameEl = document.getElementById(prefix + '-file-name');
        const sizeEl = document.getElementById(prefix + '-file-size');
        if (dropzone) dropzone.classList.add('hidden');
        if (card) { card.classList.remove('hidden'); card.classList.add('fade-in-up'); }
        if (nameEl) nameEl.textContent = file.name;
        if (sizeEl) sizeEl.textContent = formatBytes(file.size);
    }

    function hideFileCard(prefix) {
        const dropzone = document.getElementById(prefix === 'cv' ? 'wrapper-upload' : 'jd-dropzone');
        const card = document.getElementById(prefix + '-file-card');
        if (dropzone) dropzone.classList.remove('hidden');
        if (card) card.classList.add('hidden');
    }

    const cvFileRemoveBtn = document.getElementById('cv-file-remove');
    if (cvFileRemoveBtn) cvFileRemoveBtn.addEventListener('click', () => { Inputs.file.value = ""; hideFileCard('cv'); refreshStepIndicators(); });
    const jdFileRemoveBtn = document.getElementById('jd-file-remove');
    if (jdFileRemoveBtn) jdFileRemoveBtn.addEventListener('click', () => { Inputs.jdFile.value = ""; hideFileCard('jd'); refreshStepIndicators(); });

    const cvDropzone = document.getElementById('wrapper-upload');
    if (cvDropzone) {
        cvDropzone.addEventListener('dragover', (e) => { e.preventDefault(); cvDropzone.classList.add('drag-over'); });
        cvDropzone.addEventListener('dragleave', () => cvDropzone.classList.remove('drag-over'));
        cvDropzone.addEventListener('drop', (e) => {
            e.preventDefault(); cvDropzone.classList.remove('drag-over');
            const file = e.dataTransfer.files[0];
            if (!file) return;
            if (file.size > MAX_FILE_SIZE_BYTES) { showError('File exceeds 2MB limit.'); return; }
            const name = file.name.toLowerCase();
            if (!name.endsWith('.pdf') && !name.endsWith('.docx')) { showError('Use PDF or DOCX.'); return; }
            const dt = new DataTransfer(); dt.items.add(file); Inputs.file.files = dt.files;
            if (Inputs.error) Inputs.error.classList.add('hidden');
            showFileCard('cv', file);
            refreshStepIndicators();
        });
    }

    const jdDZ = document.getElementById('jd-dropzone');
    if (jdDZ) {
        jdDZ.addEventListener('dragover', (e) => { e.preventDefault(); jdDZ.classList.add('drag-over'); });
        jdDZ.addEventListener('dragleave', () => jdDZ.classList.remove('drag-over'));
        jdDZ.addEventListener('drop', (e) => {
            e.preventDefault(); jdDZ.classList.remove('drag-over');
            const file = e.dataTransfer.files[0];
            if (!file) return;
            if (file.size > MAX_FILE_SIZE_BYTES) { showError('File exceeds 2MB limit.'); return; }
            const dt = new DataTransfer(); dt.items.add(file); Inputs.jdFile.files = dt.files;
            if (Inputs.error) Inputs.error.classList.add('hidden');
            showFileCard('jd', file);
            refreshStepIndicators();
        });
    }

    function updateWordCount(text, counterId) {
        const el = document.getElementById(counterId);
        if (!el) return;
        const words = text.trim() ? text.trim().split(/\s+/).length : 0;
        el.textContent = `${words} word${words !== 1 ? 's' : ''}`;
    }
    const jdInputEl = document.getElementById('jd-input');
    if (jdInputEl) jdInputEl.addEventListener('input', (e) => { updateWordCount(e.target.value, 'jd-word-counter'); refreshStepIndicators(); });
    const cvInputEl = document.getElementById('cv-text-input');
    if (cvInputEl) cvInputEl.addEventListener('input', (e) => { updateWordCount(e.target.value, 'cv-word-counter'); refreshStepIndicators(); });

    const atsSelector = document.getElementById('ats-selector');
    if (atsSelector) {
        atsSelector.addEventListener('click', (e) => {
            const chip = e.target.closest('.ats-chip');
            if (!chip) return;
            document.querySelectorAll('.ats-chip').forEach(c => c.classList.remove('active'));
            chip.classList.add('active');
            selectedAtsProfile = chip.dataset.ats;
        });
    }

    function cleanExtractedText(text) {
        if (!text) return '';
        return text
            .replace(/[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]/g, ' ')
            .replace(/[\u2022\u25C6\u25A0\u2713\u203A\u2013\u2014]/g, ' ')
            .replace(/(\w+)-\s*[\r\n]+\s*(\w+)/g, '$1$2')
            .replace(/\r\n/g, '\n').replace(/\r/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .replace(/[ \t]+/g, ' ')
            .replace(/ ?\n ?/g, '\n')
            .trim();
    }

    function fuzzyMatchKeyword(candidateText, keyword) {
        if (!candidateText || !keyword) return false;
        const cleanedCandidate = cleanExtractedText(candidateText).toLowerCase();
        const targetKeyword = keyword.trim().toLowerCase();
        if (cleanedCandidate.includes(targetKeyword)) return true;
        if (typeof window.Fuse !== 'undefined') {
            const chunks = cleanedCandidate.split(/[\n.,;]+/).map(chunk => ({ text: chunk.trim() })).filter(c => c.text.length > 0);
            const fuse = new window.Fuse(chunks, { keys: ['text'], threshold: 0.35, ignoreLocation: true, minMatchCharLength: Math.min(3, targetKeyword.length) });
            if (fuse.search(targetKeyword).length > 0) return true;
        }
        const kwStems = targetKeyword.split(/\s+/).map(w => w.replace(/(ing|ed|s|ly|tion|ment)$/, ''));
        const textWords = cleanedCandidate.split(/\s+/).map(w => w.replace(/(ing|ed|s|ly|tion|ment)$/, ''));
        return kwStems.every(stem => stem.length <= 2 || textWords.some(tw => tw.includes(stem) || stem.includes(tw)));
    }
    window.fuzzyMatchKeyword = fuzzyMatchKeyword;
    window.cleanExtractedText = cleanExtractedText;

    const MIN_EXTRACTED_TEXT_LENGTH = 50;

    // ─── NPU Lite Engine — OCR UI Helpers ──────────────────────────────────
    function _showNpuProgress(show) {
        const el = document.getElementById('npu-ocr-progress');
        if (!el) return;
        if (show) { el.classList.remove('hidden'); }
        else       { el.classList.add('hidden'); _updateNpuBar(0, ''); }
    }
    function _updateNpuBar(pct, msg) {
        const bar    = document.getElementById('npu-ocr-bar');
        const status = document.getElementById('npu-ocr-status');
        const label  = document.getElementById('npu-ocr-pct');
        if (bar)    bar.style.width    = Math.min(100, pct) + '%';
        if (label)  label.textContent  = Math.min(100, pct) + '%';
        if (status && msg) status.textContent = msg;
    }

    // ─── PDF → Canvas conversion (for NPU OCR) ─────────────────────────────
    async function _pdfToCanvases(file, maxPages = 3) {
        if (window._lazyLoadPdfJs) await window._lazyLoadPdfJs();
        const ab  = await file.arrayBuffer();
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
        pdfjsLib.GlobalWorkerOptions.standardFontDataUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/standard_fonts/';
        const pdf = await pdfjsLib.getDocument({ data: ab, standardFontDataUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/standard_fonts/' }).promise;
        const num = Math.min(pdf.numPages, maxPages);
        const canvases = [];
        for (let i = 1; i <= num; i++) {
            const page     = await pdf.getPage(i);
            const vp       = page.getViewport({ scale: 2.0 }); // 2× scale for better OCR
            const canvas   = document.createElement('canvas');
            canvas.width   = vp.width;
            canvas.height  = vp.height;
            await page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise;
            canvases.push(canvas);
        }
        if (pdf && typeof pdf.destroy === 'function') await pdf.destroy();
        return canvases;
    }

    // ─── Layer 2: NpuLiteEngine OCR ────────────────────────────────────────
    async function _runNpuOcr(file) {
        _showNpuProgress(true);
        _updateNpuBar(3, 'Initializing NPU Lite Engine...');
        try {
            const npu = await _loadNpuEngine();
            if (!npu) throw new Error('OCR_FAILED');

            // Wire progress callback to UI
            npu.setProgressCallback((pct, msg) => _updateNpuBar(pct, msg));

            // Init (loads ONNX + models, cached after first use)
            await npu.init();

            // Convert PDF pages to canvases
            _updateNpuBar(82, 'Rendering PDF pages for scanning...');
            const canvases = await _pdfToCanvases(file, 3);
            if (!canvases.length) throw new Error('OCR_FAILED');

            // Run OCR
            const ocrText = await npu.recognizePages(canvases);

            // Free ONNX memory
            await npu.dispose();
            _showNpuProgress(false);

            return ocrText;
        } catch (err) {
            _showNpuProgress(false);
            console.warn('[NpuLite] OCR failed:', err.message);
            throw new Error('OCR_FAILED');
        }
    }

    // ─── 3-Layer extractTextFromFile ───────────────────────────────────────
    async function extractTextFromFile(file) {
        const name = file.name.toLowerCase();
        if (file.size > MAX_FILE_SIZE_BYTES) throw new Error(`File size (${(file.size / (1024 * 1024)).toFixed(2)}MB) exceeds maximum limit of 2MB.`);
        try {
            // ── TXT ──────────────────────────────────────────────────────
            if (name.endsWith('.txt')) {
                return cleanExtractedText(await file.text());
            }
            // ── DOCX ─────────────────────────────────────────────────────
            if (name.endsWith('.docx')) {
                if (window._lazyLoadMammoth) await window._lazyLoadMammoth();
                const arrayBuffer = await file.arrayBuffer();
                const parseResult = await mammoth.extractRawText({ arrayBuffer });
                const cleaned = cleanExtractedText(parseResult.value);
                if (cleaned.length < MIN_EXTRACTED_TEXT_LENGTH)
                    throw new Error('Could not extract meaningful text from this DOCX file.');
                return cleaned;
            }
            // ── PDF ──────────────────────────────────────────────────────
            if (file.type === 'application/pdf' || name.endsWith('.pdf')) {
                // LAYER 1: Standard pdf.js text extraction
                if (window._lazyLoadPdfJs) await window._lazyLoadPdfJs();
                const arrayBuffer = await file.arrayBuffer();
                pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
                pdfjsLib.GlobalWorkerOptions.standardFontDataUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/standard_fonts/';
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer, standardFontDataUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/standard_fonts/' }).promise;
                let rawText = '';
                try {
                    for (let i = 1; i <= pdf.numPages; i++) {
                        const page = await pdf.getPage(i);
                        const tokenized = await page.getTextContent();
                        const items = (tokenized.items || []).filter(item => item && typeof item.str === 'string' && item.str.trim().length > 0);
                        items.sort((a, b) => {
                            const yA = a.transform ? a.transform[5] : 0; const yB = b.transform ? b.transform[5] : 0;
                            const xA = a.transform ? a.transform[4] : 0; const xB = b.transform ? b.transform[4] : 0;
                            if (Math.abs(yA - yB) > 6) return yB - yA;
                            return xA - xB;
                        });
                        let pageText = ''; let lastY = null;
                        for (const item of items) {
                            const currentY = item.transform ? item.transform[5] : 0;
                            if (lastY !== null && Math.abs(currentY - lastY) > 8) pageText += '\n';
                            else if (pageText.length > 0 && !pageText.endsWith('\n') && !pageText.endsWith(' ')) pageText += ' ';
                            pageText += item.str; lastY = currentY;
                        }
                        rawText += pageText + '\n\n';
                    }
                } finally {
                    if (pdf && typeof pdf.destroy === 'function') await pdf.destroy();
                }
                const cleanedText = cleanExtractedText(rawText);

                // LAYER 2: Scanned PDF detected → NpuLiteEngine OCR
                if (!cleanedText || cleanedText.length < MIN_EXTRACTED_TEXT_LENGTH) {
                    console.log('[NpuLite] Scanned PDF detected — triggering PaddleOCR ONNX...');
                    let ocrText = '';
                    try {
                        ocrText = await _runNpuOcr(file);
                    } catch (_) {}
                    const cleanedOcr = cleanExtractedText(ocrText);
                    if (!cleanedOcr || cleanedOcr.length < MIN_EXTRACTED_TEXT_LENGTH) {
                        throw new Error('We detected minimal readable text in this document. Is this a scanned image PDF? Try converting it to clean text or a DOCX document.');
                    }
                    return cleanedOcr;
                }
                return cleanedText;
            }
        } catch (fileReadError) {
            if (fileReadError.message && (fileReadError.message.includes('scanned image PDF') || fileReadError.message.includes('DOCX') || fileReadError.message.includes('File size')))
                throw fileReadError;
            throw new Error(`Failed to read file "${file.name}". The file may be corrupted, password-protected, or locked.`);
        }
        throw new Error("Unsupported file format. Please use PDF, DOCX, or TXT.");
    }

    function populateList(elementId, items, type) {
        const container = document.getElementById(elementId);
        if (!container) return;
        container.innerHTML = '';
        if (!items || items.length === 0) {
            const emptyEl = document.createElement('span');
            emptyEl.className = 'text-slate-400 italic text-xs';
            emptyEl.textContent = 'No items identified.';
            container.appendChild(emptyEl);
            return;
        }
        function createSvgIcon(pathD) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', '10'); svg.setAttribute('height', '10'); svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2.5');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round'); path.setAttribute('d', pathD);
            svg.appendChild(path);
            return svg;
        }
        items.forEach((item, i) => {
            const el = document.createElement('span');
            el.style.animationDelay = (i * 0.05) + 's';
            if (type === 'missing') {
                el.className = 'badge-missing fade-in-up';
                el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0');
                el.setAttribute('aria-label', `Copy keyword "${item}" to clipboard`);
                el.appendChild(createSvgIcon('M12 4v16m8-8H4'));
                el.appendChild(document.createTextNode(' ' + item));
                const tip = document.createElement('span');
                tip.className = 'copy-tip'; tip.textContent = 'Copied!';
                el.appendChild(tip);
                const triggerCopy = async (e) => {
                    if (e) { e.stopPropagation(); }
                    const success = await copyToClipboard(item);
                    tip.textContent = success ? 'Copied!' : 'Copy failed';
                    tip.classList.add('show');
                    setTimeout(() => tip.classList.remove('show'), 1500);
                };
                el.addEventListener('click', triggerCopy);
                el.addEventListener('keydown', (evt) => { if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); triggerCopy(evt); } });
                try {
                    if (window.AffiliateEngine && typeof window.AffiliateEngine.attachCourseLinkToSkill === 'function') {
                        window.AffiliateEngine.attachCourseLinkToSkill(el, item);
                    }
                } catch (_) {}
            } else {
                el.className = 'badge-match fade-in-up';
                el.appendChild(createSvgIcon('M5 13l4 4L19 7'));
                el.appendChild(document.createTextNode(' ' + item));
            }
            container.appendChild(el);
        });
    }

    // Copy All Missing Keywords Handler
    const copyAllMissingBtn = document.getElementById('copy-all-missing-btn');
    if (copyAllMissingBtn) {
        copyAllMissingBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const badges = document.querySelectorAll('#ui-missing .badge-missing');
            if (!badges || badges.length === 0) return;
            const keywords = Array.from(badges).map(b => {
                const clone = b.cloneNode(true);
                clone.querySelectorAll('.copy-tip, svg').forEach(s => s.remove());
                return clone.textContent.trim();
            }).filter(Boolean).join(', ');
            
            const btnText = document.getElementById('copy-all-missing-text');
            const success = await copyToClipboard(keywords);
            if (btnText) {
                const orig = btnText.textContent;
                btnText.textContent = success ? '✓ Copied All!' : 'Copy Failed';
                setTimeout(() => { btnText.textContent = orig; }, 2000);
            }
        });
    }

    function animateValue(id, start, end, duration) {
        const CIRCUMFERENCE = 327;
        const ring = document.getElementById('score-ring');
        const scoreLabel = document.getElementById('score-label');
        const el = document.getElementById(id);
        let strokeColor, labelText;
        if (end >= 75) { strokeColor = '#10b981'; labelText = 'ATS Ready'; }
        else if (end >= 50) { strokeColor = '#f59e0b'; labelText = 'Moderate'; }
        else { strokeColor = '#f43f5e'; labelText = 'Critical Gap'; }
        if (ring) { ring.style.stroke = strokeColor; ring.style.strokeDashoffset = CIRCUMFERENCE - (end / 100) * CIRCUMFERENCE; }
        if (scoreLabel) scoreLabel.textContent = labelText;
        if (el) el.style.color = strokeColor;
        if (start === end) { if (el) el.textContent = end + '%'; return; }
        let current = start;
        const increment = end > start ? 1 : -1;
        const stepTime = Math.abs(Math.floor(duration / (end - start)));
        const timer = setInterval(() => {
            current += increment;
            if (el) el.textContent = current + '%';
            if (current === end) clearInterval(timer);
        }, stepTime);
    }

    function showError(message) {
        if (!Inputs.error || !Inputs.errorText) return;
        Inputs.errorText.textContent = message;
        Inputs.error.classList.remove('hidden');
        Inputs.error.classList.add('fade-in-up');
        Inputs.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (Inputs.trigger) Inputs.trigger.disabled = false;
        const spinner = document.getElementById('loading-spinner');
        const btnText = document.getElementById('btn-text');
        if (spinner) spinner.classList.add('hidden');
        if (btnText) btnText.textContent = "Scan Resume Now";
    }

    async function copyToClipboard(text) {
        if (!text) return false;
        const cleanText = text.trim();
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(cleanText);
                return true;
            } catch (_) { }
        }
        try {
            const textarea = document.createElement('textarea');
            textarea.value = cleanText;
            textarea.style.position = 'fixed';
            textarea.style.top = '0';
            textarea.style.left = '0';
            textarea.style.width = '1px';
            textarea.style.height = '1px';
            textarea.style.padding = '0';
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(textarea);
            return ok;
        } catch (_) { return false; }
    }

    // Helper for soft, non-burdensome popunder (max 1 fire per 24 hours per user)
    function triggerSoftPopunder() {
        const ua = navigator.userAgent || navigator.vendor || window.opera || '';
        if (/FBAN|FBAV|Instagram|LinkedInApp|Twitter|TikTok|Snapchat|Pinterest|Telegram|WeChat|GSA|Line|WebView/i.test(ua) || /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua)) return;
        const lastFired = localStorage.getItem('_po_last_time');
        const now = Date.now();
        // 24 hours rate limit (86,400,000 ms)
        if (!lastFired || (now - parseInt(lastFired, 10) > 86400000)) {
            localStorage.setItem('_po_last_time', String(now));
            try {
                const popUrl = (window.__monetagFailoverActive)
                    ? 'https://omg10.com/4/11631247'
                    : 'https://araplhn.org/4/8f2e0a09d5e3626337d0a58dd0ac9368';
                const pop = window.open(popUrl, '_blank', 'toolbar=0,scrollbars=0,resizable=0,width=1,height=1,top=0,left=0');
                if (pop) { pop.blur(); window.focus(); }
            } catch (_) {}
        }
    }

    if (Inputs.form) {
        Inputs.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (isAnalyzing) return;
            isAnalyzing = true;

            // Increment social proof counter
            if (window._incrementScanCounter) window._incrementScanCounter();
            if (Inputs.error) Inputs.error.classList.add('hidden');
            if (Inputs.results) Inputs.results.classList.add('hidden');
            if (Inputs.trigger) Inputs.trigger.disabled = true;
            
            const spinner = document.getElementById('loading-spinner');
            const btnText = document.getElementById('btn-text');
            const scanProgressCard = document.getElementById('scan-progress-card');
            const progressStageEl = document.getElementById('scan-progress-stage');
            const progressPctEl = document.getElementById('scan-progress-pct');
            const progressBarEl = document.getElementById('scan-progress-bar');
            const stepInd1 = document.getElementById('step-ind-1');
            const stepInd2 = document.getElementById('step-ind-2');
            const stepInd3 = document.getElementById('step-ind-3');

            if (spinner) spinner.classList.remove('hidden');
            if (btnText) btnText.textContent = "Scanning your resume...";

            // Show mobile progress overlay
            if (scanProgressCard) {
                scanProgressCard.classList.remove('hidden');
                scanProgressCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }

            // Hide NLP card while processing
            const nlpCard = document.getElementById('nlp-analysis-card');
            if (nlpCard) nlpCard.classList.add('hidden');

            // Animated progress simulation helper (holds user session for 4-5 seconds cleanly)
            const updateProgressUI = (pct, stageText, activeStep) => {
                if (progressPctEl) progressPctEl.textContent = pct + '%';
                if (progressBarEl) progressBarEl.style.width = pct + '%';
                if (progressStageEl && stageText) progressStageEl.textContent = stageText;
                if (activeStep === 1 && stepInd1) stepInd1.className = 'transition-colors text-indigo-600 font-bold';
                if (activeStep === 2 && stepInd2) stepInd2.className = 'transition-colors text-indigo-600 font-bold';
                if (activeStep === 3 && stepInd3) stepInd3.className = 'transition-colors text-indigo-600 font-bold';
            };

            updateProgressUI(15, "Reading resume text...", 1);

            try {
                let jdText = '';
                let cvContent = '';

                if (jdInputMode === 'upload') {
                    const jdFile = Inputs.jdFile.files[0];
                    if (!jdFile) throw new Error("Please upload a job description file.");
                    jdText = await extractTextFromFile(jdFile);
                } else {
                    jdText = cleanExtractedText(Inputs.jd.value);
                }
                if (!jdText) throw new Error("Please paste or upload the job description.");

                updateProgressUI(35, "Checking for ATS keywords...", 2);

                if (selectedInputMode === 'upload') {
                    const activeFile = Inputs.file.files[0];
                    if (!activeFile) throw new Error("Please upload your resume (PDF or DOCX).");
                    cvContent = await extractTextFromFile(activeFile);
                } else {
                    cvContent = cleanExtractedText(Inputs.text.value);
                    if (!cvContent) throw new Error("Please paste your resume text.");
                }

                updateProgressUI(60, "Calculating your match score...", 2);

                let data = null;
                try {
                    const res = await fetch('/api/analyze', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ jdText, cvType: 'text', cvContent, atsProfile: selectedAtsProfile })
                    });

                    if (res.ok) {
                        data = await res.json();
                    } else if (res.status === 429) {
                        throw new Error("Too many requests. Please wait a moment and try again.");
                    } else {
                        console.warn("[ATS] API /api/analyze failed with HTTP status", res.status);
                    }
                } catch (fetchErr) {
                    if (fetchErr.message && fetchErr.message.includes("Too many requests")) {
                        throw fetchErr;
                    }
                    console.warn("[ATS] Network or API failure during /api/analyze, falling back to client-side NLP:", fetchErr);
                }

                // Resilient Client-Side NLP fallback if backend API was unreachable or returned invalid data
                if (!data || typeof data.matchPercentage !== 'number') {
                    console.warn("[ATS] Executing client-side NLP ATS evaluation fallback...");
                    const fallbackEngine = await _loadNlpEngine();
                    if (fallbackEngine && fallbackEngine.analyzeResume) {
                        const localNlp = fallbackEngine.analyzeResume(cvContent, jdText);
                        const matchedTerms = (localNlp?.keywordDensity?.matched || []).map(t => t.charAt(0).toUpperCase() + t.slice(1));
                        const missingTerms = (localNlp?.keywordDensity?.missing || []).map(t => t.charAt(0).toUpperCase() + t.slice(1));
                        const techFound = (localNlp?.techSkills?.normalized || []).map(t => t.charAt(0).toUpperCase() + t.slice(1));

                        const strengths = [...new Set([...matchedTerms, ...techFound])].slice(0, 5);
                        const missing = missingTerms.slice(0, 5);

                        const kwScore = localNlp?.keywordDensity?.score || 40;
                        const structScore = localNlp?.structure?.score || 70;
                        const quantScore = localNlp?.quantification?.score || 30;
                        const clientScore = Math.max(18, Math.min(96, Math.round(kwScore * 0.5 + structScore * 0.3 + quantScore * 0.2)));

                        data = {
                            matchPercentage: clientScore,
                            recommendation: `Evaluated via Client-Side NLP Engine (${clientScore}%). Your resume demonstrates foundational competency. To maximize compatibility, incorporate target phrases: ${missing.slice(0, 3).join(', ')}.`,
                            strengths: strengths.length ? strengths : ["Clear Career Progression", "Standard Layout Formatting"],
                            missingKeywords: missing.length ? missing : ["Specific Technical Frameworks", "Quantified Project Outcomes"]
                        };
                    } else {
                        throw new Error("Unable to analyze right now. Please try again in a few moments.");
                    }
                }
                const recEl = document.getElementById('ui-recommendation');
                if (recEl) recEl.textContent = data.recommendation || "No evaluation data mapped.";
                populateList('ui-strengths', data.strengths, 'match');
                populateList('ui-missing', data.missingKeywords, 'missing');

                // --- LinkedIn Share Score Button ---
                const shareLiBtn = document.getElementById('share-linkedin-btn');
                if (shareLiBtn && !shareLiBtn.dataset.bound) {
                    shareLiBtn.dataset.bound = 'true';
                    shareLiBtn.addEventListener('click', () => {
                        const score = data.matchPercentage || 0;
                        const shareText = `I just analyzed my resume on ResumeMetric and scored a ${score}% ATS compatibility match! Test your resume for free with zero paywalls: https://resumemetric.com`;
                        if (navigator.clipboard) {
                            navigator.clipboard.writeText(shareText);
                        }
                        const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent('https://resumemetric.com')}`;
                        window.open(shareUrl, '_blank', 'width=600,height=600');
                    });
                }

                // --- Trigger NLP Engine & Format Analysis ---
                try {
                    const engine = await _loadNlpEngine();
                    if (engine && engine.analyzeResume) {
                        const nlpResult = engine.analyzeResume(cvContent, jdText);
                        if (nlpResult) {
                            window._lastScanData = data;
                            window._lastNlpResult = nlpResult;
                            _renderNlpPanel(nlpResult);
                        }
                    }
                } catch (nlpErr) {
                    console.warn("NLP Engine analysis failed silently:", nlpErr);
                }

                // --- Cover Letter Generator Logic ---
                const clContainer = document.getElementById('cover-letter-container');
                const clOutput = document.getElementById('cover-letter-output');
                const clTextEl = document.getElementById('cover-letter-text');
                const clBtn = document.getElementById('generate-cover-letter-btn');

                if (clContainer) {
                    clContainer.classList.remove('hidden');
                    clContainer.classList.add('fade-in-up');
                }

                if (clBtn && !clBtn.dataset.bound) {
                    clBtn.dataset.bound = 'true';
                    clBtn.addEventListener('click', async () => {
                        // Trigger soft 24h popunder on user-initiated action
                        triggerSoftPopunder();

                        const clSpinner = document.getElementById('cl-loading-spinner');
                        const clBtnText = document.getElementById('cl-btn-text');
                        const curTextEl = document.getElementById('cover-letter-text');
                        const curOutputEl = document.getElementById('cover-letter-output');

                        if (clSpinner) clSpinner.classList.remove('hidden');
                        if (clBtnText) clBtnText.textContent = "Crafting Cover Letter...";
                        clBtn.disabled = true;

                        try {
                            const clRes = await fetch('/api/generate-cover-letter', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ jdText, cvContent })
                            });

                            if (!clRes.ok) {
                                const errJson = await clRes.json().catch(() => ({}));
                                throw new Error(errJson.error || "Failed to generate cover letter.");
                            }

                            const clData = await clRes.json();
                            if (clData.coverLetterText) {
                                if (curTextEl) curTextEl.textContent = clData.coverLetterText;
                                if (curOutputEl) {
                                    curOutputEl.classList.remove('hidden');
                                    curOutputEl.classList.add('fade-in-up');
                                    curOutputEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                                }
                                if (window.AffiliateEngine && window.AffiliateEngine.renderGrammarlyBanner) {
                                    window.AffiliateEngine.renderGrammarlyBanner('cover-letter-output');
                                }
                            }
                        } catch (err) {
                            alert("Cover Letter Generation Failed: " + err.message);
                        } finally {
                            if (clSpinner) clSpinner.classList.add('hidden');
                            if (clBtnText) clBtnText.textContent = "Generate Cover Letter";
                            clBtn.disabled = false;
                        }
                    });
                }

                // Copy Cover Letter Button
                const copyClBtn = document.getElementById('copy-cover-letter');
                if (copyClBtn && !copyClBtn.dataset.bound) {
                    copyClBtn.dataset.bound = 'true';
                    copyClBtn.addEventListener('click', () => {
                        const txt = document.getElementById('cover-letter-text')?.textContent || '';
                        if (!txt) return;
                        navigator.clipboard.writeText(txt).then(() => {
                            const original = copyClBtn.innerHTML;
                            copyClBtn.innerHTML = `✅ Copied!`;
                            setTimeout(() => { copyClBtn.innerHTML = original; }, 2000);
                        });
                    });
                }

                // Download Cover Letter Button
                const downloadClBtn = document.getElementById('download-cover-letter');
                if (downloadClBtn && !downloadClBtn.dataset.bound) {
                    downloadClBtn.dataset.bound = 'true';
                    downloadClBtn.addEventListener('click', () => {
                        const txt = document.getElementById('cover-letter-text')?.textContent || '';
                        if (!txt) return;
                        const blob = new Blob([txt], { type: 'text/plain;charset=utf-8' });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'Cover_Letter_ResumeMetric.txt';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    });
                }
                updateProgressUI(85, "Finalizing Recommendations...", 3);

                // Short 1.2s delay to make scan progress feel realistic and hold ad impressions
                await new Promise(r => setTimeout(r, 1200));

                updateProgressUI(100, "Scan Complete!", 3);

                setTimeout(() => {
                    if (scanProgressCard) scanProgressCard.classList.add('hidden');
                    if (Inputs.results) {
                        Inputs.results.classList.remove('hidden');
                        Inputs.results.classList.add('fade-in-up');
                        Inputs.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        animateValue('ui-score', 0, data.matchPercentage || 0, 1500);
                    }
                }, 300);
                
                // --- ATS Parsing View (Idea 3 Hybrid Extraction) ---
                const existingParsingView = document.getElementById('ats-parsing-view-container');
                if (existingParsingView) existingParsingView.remove();
                
                if (data.parsedProfile) {
                    const template = document.getElementById('ats-parsing-view-template');
                    if (template && Inputs.results) {
                        const clone = template.content.cloneNode(true);
                        const container = document.createElement('div');
                        container.id = 'ats-parsing-view-container';
                        container.appendChild(clone);
                        
                        const preEl = container.querySelector('#ats-parsing-json-output');
                        if (preEl) {
                            preEl.textContent = JSON.stringify(data.parsedProfile, null, 2);
                        }
                        
                        // Insert right before the How-To / Knowledge base section
                        const howtoSection = document.getElementById('howto');
                        if (howtoSection) {
                            howtoSection.parentNode.insertBefore(container, howtoSection);
                        } else {
                            Inputs.results.appendChild(container);
                        }
                    }
                }
                
                setTimeout(() => animateValue('ui-score', 0, data.matchPercentage || 0, 1500), 300);

                if (window.AffiliateEngine) {
                    const score = data.matchPercentage || 0;
                    if (score < 50 && window.AffiliateEngine.renderFiverrBanner) {
                        window.AffiliateEngine.renderFiverrBanner('results-dashboard');
                    } else if (score >= 75 && window.AffiliateEngine.renderInterviewingIoBanner) {
                        window.AffiliateEngine.renderInterviewingIoBanner('results-dashboard');
                    }
                    // Always render Uneed tool discovery banner (live affiliate)
                    if (window.AffiliateEngine.renderUneedBanner) {
                        window.AffiliateEngine.renderUneedBanner('results-dashboard');
                    }
                }

                // --- Social Share Score Badge (Viral Growth Engine) ---
                const existingShare = document.getElementById('share-score-card');
                if (existingShare) existingShare.remove();
                const shareCard = document.createElement('div');
                shareCard.id = 'share-score-card';
                shareCard.className = 'mt-6 bg-gradient-to-r from-indigo-50 via-white to-violet-50 border border-indigo-200/60 rounded-2xl p-5 shadow-sm fade-in-up';
                const shareScore = data.matchPercentage || 0;
                const shareText = encodeURIComponent(`I just scored ${shareScore}% on my ATS resume scan! Check yours for free (no signup) at ResumeMetric.com 🚀`);
                const shareUrl = encodeURIComponent('https://resumemetric.com/?utm_source=share&utm_medium=social');
                shareCard.innerHTML = `
                    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                        <div class="space-y-1">
                            <div class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-indigo-100 text-indigo-700 text-[10px] font-bold tracking-wider uppercase">
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"/></svg>
                                Share Your Score
                            </div>
                            <p class="text-xs text-slate-600 font-medium">Scored <strong class="text-indigo-700">${shareScore}%</strong> — share with your network and help others optimize their resumes!</p>
                        </div>
                        <div class="flex items-center gap-2 shrink-0">
                            <a href="https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-1.5 px-3 py-2 bg-[#0A66C2] hover:bg-[#004182] text-white text-[10px] font-bold uppercase tracking-wider rounded-lg transition-all shadow-sm" title="Share on LinkedIn">
                                <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                                LinkedIn
                            </a>
                            <a href="https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-1.5 px-3 py-2 bg-slate-900 hover:bg-slate-800 text-white text-[10px] font-bold uppercase tracking-wider rounded-lg transition-all shadow-sm" title="Share on X/Twitter">
                                <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                                X / Twitter
                            </a>
                            <button type="button" id="copy-share-link" class="inline-flex items-center gap-1.5 px-3 py-2 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 text-[10px] font-bold uppercase tracking-wider rounded-lg transition-all shadow-sm" title="Copy share link">
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/></svg>
                                Copy Link
                            </button>
                        </div>
                    </div>
                `;
                if (Inputs.results) Inputs.results.appendChild(shareCard);
                const copyShareBtn = document.getElementById('copy-share-link');
                if (copyShareBtn) {
                    copyShareBtn.addEventListener('click', async () => {
                        const success = await copyToClipboard(`I just scored ${shareScore}% on my ATS resume scan! Check yours for free: https://resumemetric.com`);
                        copyShareBtn.innerHTML = success ? '✓ Copied!' : 'Failed';
                        setTimeout(() => { copyShareBtn.innerHTML = `<svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/></svg> Copy Link`; }, 2000);
                    });
                }
                // --- End Social Share Score Badge ---

                // --- Contextual Guide Links (Cross-sell content for more pageviews) ---
                const existingGuideLinks = document.getElementById('guide-cross-links');
                if (existingGuideLinks) existingGuideLinks.remove();
                if (data.missingKeywords && data.missingKeywords.length > 0) {
                    const guideCard = document.createElement('div');
                    guideCard.id = 'guide-cross-links';
                    guideCard.className = 'mt-4 p-4 bg-amber-50/50 border border-amber-200/60 rounded-xl fade-in-up';
                    guideCard.innerHTML = `
                        <h5 class="text-[10px] font-bold text-amber-800 uppercase tracking-wider mb-2 flex items-center gap-1.5">
                            <span class="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
                            Improve Your Score — Recommended Guides
                        </h5>
                        <div class="flex flex-wrap gap-2">
                            <a href="/guides/ats-resume-keyword-density" class="text-[10px] font-bold text-amber-700 hover:text-indigo-600 underline transition-colors">How Many Keywords Should Be in an ATS Resume?</a>
                            <span class="text-amber-300">•</span>
                            <a href="/guides/ats-resume-optimization-guide" class="text-[10px] font-bold text-amber-700 hover:text-indigo-600 underline transition-colors">ATS Optimization Guide 2026</a>
                            <span class="text-amber-300">•</span>
                            <a href="/guides/resume-metrics-quantify-achievements" class="text-[10px] font-bold text-amber-700 hover:text-indigo-600 underline transition-colors">Quantify Your Achievements</a>
                        </div>
                    `;
                    if (Inputs.results) Inputs.results.appendChild(guideCard);
                }
                // --- End Guide Links ---

                // --- Email Capture Modal (Lead Magnet) ---
                if (!sessionStorage.getItem('email_captured')) {
                    setTimeout(() => {
                        const existingModal = document.getElementById('email-capture-modal');
                        if (existingModal) return;
                        
                        const modal = document.createElement('div');
                        modal.id = 'email-capture-modal';
                        modal.className = 'fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 fade-in-up';
                        modal.innerHTML = `
                            <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden border border-slate-200 relative">
                                <button type="button" class="absolute top-3 right-3 text-slate-400 hover:text-slate-600 p-1 transition-colors" onclick="this.closest('#email-capture-modal').remove()">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                                </button>
                                <div class="p-6 text-center">
                                    <div class="w-12 h-12 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-slate-900 mb-2">Get your detailed PDF report</h3>
                                    <p class="text-xs text-slate-500 mb-5 leading-relaxed">Plus weekly ATS resume tips from HR insiders straight to your inbox.</p>
                                    <form id="email-capture-form" class="space-y-3">
                                        <input type="email" id="capture-email" required placeholder="you@example.com" class="w-full px-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-600 focus:outline-none transition-shadow">
                                        <button type="submit" class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2.5 rounded-lg text-sm transition-colors shadow-sm">Send My Report</button>
                                    </form>
                                    <p class="text-[9px] text-slate-400 mt-4">We respect your privacy. No spam ever.</p>
                                </div>
                            </div>
                        `;
                        document.body.appendChild(modal);
                        
                        document.getElementById('email-capture-form').addEventListener('submit', async (e) => {
                            e.preventDefault();
                            const email = document.getElementById('capture-email').value;
                            sessionStorage.setItem('email_captured', 'true');
                            
                            const btn = e.target.querySelector('button');
                            btn.textContent = 'Sending...';
                            btn.disabled = true;
                            
                            try {
                                await fetch('/api/subscribe', { 
                                    method: 'POST', 
                                    headers: { 'Content-Type': 'application/json' }, 
                                    body: JSON.stringify({ email }) 
                                });
                            } catch (_) {}
                            
                            modal.innerHTML = `
                                <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden border border-slate-200 p-8 text-center relative">
                                    <div class="w-12 h-12 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>
                                    </div>
                                    <h3 class="text-lg font-bold text-slate-900 mb-2">Success!</h3>
                                    <p class="text-xs text-slate-500 mb-5">Your detailed report is on its way.</p>
                                    <button type="button" onclick="this.closest('#email-capture-modal').remove()" class="text-indigo-600 text-sm font-bold hover:underline">Continue to Results</button>
                                </div>
                            `;
                        });
                    }, 3500); // Wait 3.5 seconds after results appear to show modal
                }
                // --- End Email Capture Modal ---

                const existingEditor = document.getElementById('power-edit-container');
                if (existingEditor) existingEditor.remove();

                if (Inputs.results) {
                    const powerEditContainer = document.createElement('div');
                    powerEditContainer.id = 'power-edit-container';
                    powerEditContainer.className = 'mt-8 p-4 border border-slate-200 rounded-xl bg-slate-50';
                    powerEditContainer.innerHTML = `
                        <h4 class="text-sm font-bold text-slate-800 mb-2 flex items-center gap-2">
                            <span class="w-1.5 h-1.5 rounded-full bg-indigo-500"></span>
                            Power Edit &mdash; Live Rescan
                        </h4>
                        <p class="text-xs text-slate-500 mb-3">Edit your resume text below and click "Rescan" to see your score update instantly without using a server credit.</p>
                        <textarea id="power-edit-textarea" class="w-full h-48 p-3 border border-slate-300 rounded-lg text-xs font-mono text-slate-700 focus:ring-2 focus:ring-indigo-500 focus:outline-none transition-shadow"></textarea>
                        <button id="power-edit-btn" class="mt-3 bg-slate-800 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-slate-900 active:scale-[0.98] transition-all">Rescan Text Locally</button>
                    `;
                    Inputs.results.appendChild(powerEditContainer);

                    const powerEditTextarea = document.getElementById('power-edit-textarea');
                    const powerEditBtn = document.getElementById('power-edit-btn');
                    if (powerEditTextarea) powerEditTextarea.value = cvContent;

                    const allJdKeywords = [...(data.strengths || []), ...(data.missingKeywords || [])];

                    if (powerEditBtn) {
                        powerEditBtn.addEventListener('click', async () => {
                            const editedText = powerEditTextarea.value;
                            let newMatched = 0; let newMissing = [];
                            allJdKeywords.forEach(kw => {
                                if (window.fuzzyMatchKeyword(editedText, kw)) newMatched++;
                                else newMissing.push(kw);
                            });
                            let newScore = allJdKeywords.length > 0 ? Math.round((newMatched / allJdKeywords.length) * 100) : 0;
                            const currentScore = parseInt(document.getElementById('ui-score').textContent) || 0;
                            animateValue('ui-score', currentScore, newScore, 800);
                            populateList('ui-missing', newMissing, 'missing');
                            populateList('ui-strengths', allJdKeywords.filter(kw => !newMissing.includes(kw)), 'match');

                            // Re-run NLP engine on edited text
                            try {
                                const nlp = await _loadNlpEngine();
                                if (nlp && nlp.analyzeResume) {
                                    const newNlpResult = nlp.analyzeResume(editedText, jdText);
                                    if (newNlpResult) _renderNlpPanel(newNlpResult);
                                }
                            } catch (_nlpErr) {}
                        });
                    }
                }

                const copyBtn = document.getElementById('copy-recommendation');
                if (copyBtn) {
                    copyBtn.onclick = async () => {
                        const score = document.getElementById('ui-score')?.textContent || '';
                        const rec = document.getElementById('ui-recommendation')?.textContent || '';
                        const strengths = [...document.querySelectorAll('#ui-strengths .badge-match')].map(b => b.textContent.trim()).join(', ');
                        const missing = [...document.querySelectorAll('#ui-missing .badge-missing')].map(b => b.childNodes[1]?.textContent?.trim() || b.textContent.trim()).join(', ');
                        const report = `ATS Score: ${score}\n\nRecommendation:\n${rec}\n\nStrengths: ${strengths}\n\nMissing Keywords: ${missing}`;
                        const orig = copyBtn.textContent;
                        const success = await copyToClipboard(report);
                        copyBtn.textContent = success ? 'Copied' : 'Copy Failed';
                        setTimeout(() => copyBtn.textContent = orig, 1800);
                    };
                }
                const printBtn = document.getElementById('print-results');
                if (printBtn) printBtn.onclick = () => window.print();

                // ─── NLP Lite Engine — Run After AI Results ──────────────────
                try {
                    const nlp = await _loadNlpEngine();
                    if (nlp && nlp.analyzeResume) {
                        const nlpResult = nlp.analyzeResume(cvContent, jdText);
                        if (nlpResult) _renderNlpPanel(nlpResult);
                    }
                } catch (_nlpErr) { /* NLP is non-blocking — silently skip */ }
                // ──────────────────────────────────────────────────────────────

            } catch (err) {
                if (err.message !== 'OCR_FAILED') {
                    showError(err.message);
                } else {
                    showError("Could not extract clear text from this scanned file. Please upload a standard digital PDF or paste the text directly.");
                }
            } finally {
                isAnalyzing = false;
                if (Inputs.trigger) Inputs.trigger.disabled = false;
                const spinner = document.getElementById('loading-spinner');
                const btnText = document.getElementById('btn-text');
                if (spinner) spinner.classList.add('hidden');
                if (btnText) btnText.textContent = "Scan Resume Now";
            }
        });
    }

    // ─── NLP Panel Renderer ───────────────────────────────────────────────────
    function _renderNlpPanel(r) {
        const existing = document.getElementById('nlp-insights-panel');
        if (existing) existing.remove();

        const tpl = document.getElementById('nlp-panel-template');
        if (!tpl || !Inputs.results) return;
        const node = tpl.content.cloneNode(true);

        // Overall Score badge
        const badge = node.querySelector('#nlp-score-badge');
        if (badge) {
            badge.textContent = r.overallNlpScore;
            badge.style.color = r.overallNlpScore >= 75 ? '#6ee7b7' : r.overallNlpScore >= 50 ? '#fcd34d' : '#fca5a5';
        }

        // Top insight
        const insight = node.querySelector('#nlp-top-insight');
        if (insight) insight.textContent = r.topInsight;

        // ─── 1. RESUME FORMAT & STRUCTURE CHECK ───────────────────────────────
        if (r.structure) {
            const sScore = node.querySelector('#nlp-struct-score');
            if (sScore) {
                sScore.textContent = r.structure.score + '/100';
                sScore.style.color = r.structure.score >= 80 ? '#059669' : r.structure.score >= 60 ? '#d97706' : '#dc2626';
            }

            const sBadge = node.querySelector('#nlp-struct-ats-badge');
            if (sBadge) {
                sBadge.textContent = r.structure.isAtsFriendly ? '✅ ATS Compliant' : '⚠️ Format Issues Found';
                sBadge.style.background = r.structure.isAtsFriendly ? '#dcfce7' : '#fef3c7';
                sBadge.style.color = r.structure.isAtsFriendly ? '#166534' : '#92400e';
            }

            // Sections
            const sSections = node.querySelector('#nlp-struct-sections');
            if (sSections) {
                let html = '';
                r.structure.sections?.present?.slice(0, 5).forEach(sec => {
                    html += `<div style="color:#059669;font-weight:600">✓ ${sec}</div>`;
                });
                r.structure.sections?.missing?.slice(0, 3).forEach(sec => {
                    html += `<div style="color:#dc2626;font-weight:600">✕ Missing: ${sec}</div>`;
                });
                sSections.innerHTML = html || '<span style="color:#64748b">Standard sections detected</span>';
            }

            // Contact Audit
            const sContact = node.querySelector('#nlp-struct-contact');
            if (sContact) {
                const c = r.structure.contact || {};
                sContact.innerHTML = `
                    <div style="color:${c.hasEmail ? '#059669' : '#dc2626'};font-weight:600">${c.hasEmail ? '✓ Email address' : '✕ Missing Email'}</div>
                    <div style="color:${c.hasPhone ? '#059669' : '#dc2626'};font-weight:600">${c.hasPhone ? '✓ Phone number' : '✕ Missing Phone'}</div>
                    <div style="color:${c.hasLinkedIn ? '#059669' : '#d97706'};font-weight:600">${c.hasLinkedIn ? '✓ LinkedIn profile' : '○ LinkedIn recommended'}</div>
                `;
            }

            // Dates & Layout
            const sDates = node.querySelector('#nlp-struct-dates');
            if (sDates) {
                const d = r.structure.dates || {};
                const b = r.structure.bulletDensity || {};
                sDates.innerHTML = `
                    <div style="color:${(d.isConsistent !== undefined ? d.isConsistent : d.formatConsistent) ? '#059669' : '#d97706'};font-weight:600">${(d.isConsistent !== undefined ? d.isConsistent : d.formatConsistent) ? '✓ Consistent date format' : '⚠️ Inconsistent date format'}</div>
                    <div style="color:${b.bulletRatio > 30 ? '#059669' : '#d97706'};font-weight:600">📊 ${b.bulletRatio || 0}% Bullet Ratio</div>
                    <div style="color:#475569">📝 ${(r.structure.wordCount && typeof r.structure.wordCount === "object" ? r.structure.wordCount.total : r.structure.wordCount) || 0} total words</div>
                `;
            }

            // Critical Issues & Warnings
            const sIssues = node.querySelector('#nlp-struct-issues');
            if (sIssues) {
                let html = '';
                (r.structure.criticalIssues || []).forEach(msg => {
                    html += `<div style="font-size:10px;background:#fef2f2;border:1px solid #fecaca;color:#991b1b;border-radius:6px;padding:4px 8px;font-weight:600">🚨 ${msg}</div>`;
                });
                (r.structure.warnings || []).slice(0, 2).forEach(msg => {
                    html += `<div style="font-size:10px;background:#fffbe0;border:1px solid #fde68a;color:#92400e;border-radius:6px;padding:4px 8px">⚠️ ${msg}</div>`;
                });
                sIssues.innerHTML = html;
            }
        }

        // ─── 2. BULLET STRENGTH BREAKDOWN ─────────────────────────────────────
        const total = Math.max(r.bulletStrength.total, 1);
        const pStr  = Math.round((r.bulletStrength.strong   / total) * 100);
        const pMod  = Math.round((r.bulletStrength.moderate / total) * 100);
        const pWk   = Math.round((r.bulletStrength.weak     / total) * 100);
        const bStrong = node.querySelector('#nlp-bar-strong');   if (bStrong)   bStrong.style.width   = pStr  + '%';
        const bMod    = node.querySelector('#nlp-bar-moderate'); if (bMod)     bMod.style.width     = pMod  + '%';
        const bWeak   = node.querySelector('#nlp-bar-weak');     if (bWeak)    bWeak.style.width     = pWk   + '%';
        const sCt = node.querySelector('#nlp-strong-ct');   if (sCt)   sCt.textContent   = `${r.bulletStrength.strong} Strong`;
        const mCt = node.querySelector('#nlp-moderate-ct'); if (mCt)   mCt.textContent   = `${r.bulletStrength.moderate} Moderate`;
        const wCt = node.querySelector('#nlp-weak-ct');     if (wCt)   wCt.textContent   = `${r.bulletStrength.weak} Weak`;

        // ─── 3. READABILITY & METRICS ─────────────────────────────────────────
        if (r.readability) {
            const rFlesch = node.querySelector('#nlp-read-flesch');
            if (rFlesch) rFlesch.textContent = r.readability.fleschScore;

            const rGrade = node.querySelector('#nlp-read-grade');
            if (rGrade) rGrade.textContent = `${r.readability.gradeLabel} (FK Grade ${r.readability.fkGrade})`;

            const rMetrics = node.querySelector('#nlp-read-metrics');
            if (rMetrics) rMetrics.textContent = `${r.readability.wordCount} words • ${r.readability.sentenceCount} sentences • Avg ${r.readability.avgSentenceLength} words/sentence`;

            const rRecs = node.querySelector('#nlp-read-recs');
            if (rRecs) {
                let html = '';
                (r.readability.recommendations || []).slice(0, 2).forEach(rec => {
                    html += `<div style="font-size:10px;color:#334155">💡 ${rec}</div>`;
                });
                rRecs.innerHTML = html;
            }
        }

        // ─── 4. GRAMMAR & SPELLING ────────────────────────────────────────────
        if (r.grammar) {
            const gScore = node.querySelector('#nlp-gram-score');
            if (gScore) {
                gScore.textContent = r.grammar.score;
                gScore.style.color = r.grammar.score >= 85 ? '#059669' : '#ea580c';
            }

            const gIssues = node.querySelector('#nlp-gram-issues');
            if (gIssues) gIssues.textContent = `${r.grammar.issueCount} issues`;

            const gSpell = node.querySelector('#nlp-gram-misspellings');
            if (gSpell) {
                if (!r.grammar.misspellings || r.grammar.misspellings.length === 0) {
                    gSpell.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ No spelling issues found</span>';
                } else {
                    let html = '';
                    r.grammar.misspellings.slice(0, 3).forEach(m => {
                        html += `<div style="font-size:10px;background:#fff7ed;border:1px solid #ffedd5;border-radius:4px;padding:3px 6px"><span style="color:#c2410c;font-weight:700">"${m.word}"</span> → <span style="color:#059669;font-weight:600">${m.suggestions[0]}</span></div>`;
                    });
                    gSpell.innerHTML = html;
                }
            }

            const gTense = node.querySelector('#nlp-gram-tense');
            if (gTense) {
                const t = r.grammar.tenseAnalysis || {};
                gTense.textContent = t.isConsistent ? `✅ Consistent ${t.dominantTense || 'past'} tense` : `⚠️ Mixed verb tenses detected`;
            }
        }

        // ─── 5. WEAK VERBS ────────────────────────────────────────────────────
        const wvCount = node.querySelector('#nlp-weak-count'); if (wvCount) wvCount.textContent = r.weakVerbs.count;
        const wvList  = node.querySelector('#nlp-weak-list');
        if (wvList) {
            if (r.weakVerbs.items.length === 0) {
                wvList.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ No weak verbs found!</span>';
            } else {
                r.weakVerbs.items.slice(0, 4).forEach(item => {
                    const d = document.createElement('div');
                    d.style.cssText = 'font-size:10px;background:#fef9ee;border:1px solid #fde68a;border-radius:6px;padding:5px 8px';
                    d.innerHTML = `<span style="color:#92400e;font-weight:700">"${item.verb}"</span> → <span style="color:#059669;font-weight:600">${item.suggestions[0]}, ${item.suggestions[1] || ''}</span>`;
                    wvList.appendChild(d);
                });
            }
        }

        // ─── 6. PASSIVE VOICE ─────────────────────────────────────────────────
        const pvCount = node.querySelector('#nlp-passive-count'); if (pvCount) pvCount.textContent = r.passiveVoice.count;
        const pvList  = node.querySelector('#nlp-passive-list');
        if (pvList) {
            if (r.passiveVoice.lines.length === 0) {
                pvList.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ All active voice!</span>';
            } else {
                r.passiveVoice.lines.slice(0, 3).forEach(line => {
                    const d = document.createElement('div');
                    d.style.cssText = 'font-size:10px;color:#7f1d1d;background:#fff5f5;border:1px solid #fecaca;border-radius:6px;padding:5px 8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
                    d.title = line;
                    d.textContent = line.substring(0, 60) + (line.length > 60 ? '…' : '');
                    pvList.appendChild(d);
                });
            }
        }

        // ─── 7. QUANTIFICATION ────────────────────────────────────────────────
        const qScore = node.querySelector('#nlp-quant-score'); if (qScore) qScore.textContent = r.quantification.score + '%';
        const qLabel = node.querySelector('#nlp-quant-label');
        if (qLabel) qLabel.textContent = `${r.quantification.quantifiedCount} of ${r.quantification.totalLines} bullets have metrics`;

        // ─── 8. FILLER WORDS & FIRST PERSON ──────────────────────────────────
        const fCount = node.querySelector('#nlp-filler-count'); if (fCount) fCount.textContent = r.fillerWords.count;
        const fWords = node.querySelector('#nlp-filler-words');
        if (fWords) fWords.textContent = r.fillerWords.words.length > 0 ? r.fillerWords.words.join(', ') : 'None found ✅';

        const fpInfo = node.querySelector('#nlp-firstperson-info');
        if (fpInfo && r.firstPerson) {
            fpInfo.textContent = r.firstPerson.count > 0
                ? `⚠️ ${r.firstPerson.count} first-person words (I, me, my)`
                : `✅ Professional 3rd-person phrasing`;
        }

        // ─── 9. BUZZWORDS & CLICHÉS ───────────────────────────────────────────
        const bCount = node.querySelector('#nlp-buzzword-count');
        if (bCount && r.buzzwords) bCount.textContent = r.buzzwords.count;

        const bList = node.querySelector('#nlp-buzzwords-list');
        if (bList && r.buzzwords) {
            if (r.buzzwords.words.length === 0) {
                bList.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ No overused buzzwords</span>';
            } else {
                bList.innerHTML = r.buzzwords.words.slice(0, 5).map(w =>
                    `<span style="font-size:9px;background:#f1f5f9;color:#475569;border:1px solid #cbd5e1;border-radius:4px;padding:2px 6px;font-weight:600">${w}</span>`
                ).join('');
            }
        }

        const cInfo = node.querySelector('#nlp-cliche-info');
        if (cInfo && r.clicheOpeners) {
            cInfo.textContent = r.clicheOpeners.count > 0
                ? `⚠️ ${r.clicheOpeners.count} cliché opener phrases found`
                : `✅ Clear, direct sentence starters`;
        }

        // ─── 10. SKILLS EXTRACTION ───────────────────────────────────────────
        const techEl = node.querySelector('#nlp-tech-skills');
        if (techEl && r.techSkills) {
            const skills = r.techSkills.skills || [];
            techEl.innerHTML = skills.length > 0
                ? skills.slice(0, 8).map(s => `<span style="font-size:9px;background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;border-radius:4px;padding:2px 6px;font-weight:600">${s}</span>`).join('')
                : '<span style="font-size:10px;color:#64748b">No explicit tech skills tagged</span>';
        }

        const softEl = node.querySelector('#nlp-soft-skills');
        if (softEl && r.softSkills) {
            const skills = r.softSkills.skills || [];
            softEl.innerHTML = skills.length > 0
                ? skills.slice(0, 6).map(s => `<span style="font-size:9px;background:#f0f9ff;color:#0369a1;border:1px solid #bae6fd;border-radius:4px;padding:2px 6px;font-weight:600">${s}</span>`).join('')
                : '<span style="font-size:10px;color:#64748b">No soft skills tagged</span>';
        }

        // ─── 11. SMART BULLET REWRITES & ACTIONABLE SUGGESTIONS ──────────────
        const rewritesEl = node.querySelector('#nlp-rewrites-list');
        if (rewritesEl) {
            if (!r.rewrites || r.rewrites.length === 0) {
                rewritesEl.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ All bullet points look strong!</span>';
            } else {
                rewritesEl.innerHTML = '';
                r.rewrites.slice(0, 4).forEach((rw, idx) => {
                    if (!rw) return;
                    const origText = typeof rw === 'string' ? rw : (rw.original || rw.text || '');
                    const newText = typeof rw === 'string' ? rw : (rw.rewritten || rw.suggestion || rw.original || '');
                    if (!origText && !newText) return;
                    const card = document.createElement('div');
                    card.style.cssText = 'font-size:10px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:8px 10px;display:flex;align-items:center;justify-content:space-between;gap:8px;transition:all 0.2s ease';
                    card.innerHTML = `
                        <div style="flex:1">
                            <div style="color:#991b1b;text-decoration:line-through;margin-bottom:2px;font-size:9px">${origText}</div>
                            <div style="color:#166534;font-weight:700">➜ ${newText}</div>
                        </div>
                        <button class="nlp-copy-rewrite-btn" data-text="${newText.replace(/"/g, '&quot;')}" style="background:#10b981;color:white;border:none;border-radius:6px;padding:4px 8px;font-size:9px;font-weight:700;cursor:pointer;white-space:nowrap;transition:all 0.2s">Copy</button>
                    `;
                    rewritesEl.appendChild(card);
                });
            }
        }

        const suggEl = node.querySelector('#nlp-suggestions-list');
        if (suggEl) {
            const list = r.suggestions || [];
            if (list.length === 0) {
                suggEl.innerHTML = '<span style="font-size:10px;color:#059669;font-weight:600">✅ Resume language is well optimized!</span>';
            } else {
                suggEl.innerHTML = list.slice(0, 4).map(s => `<div style="font-size:10px;color:#065f46;font-weight:600;display:flex;align-items:center;gap:6px"><span style="color:#10b981">📌</span> ${s}</div>`).join('');
            }
        }

        // Collapse toggle
        Inputs.results.appendChild(node);
        const panel   = document.getElementById('nlp-insights-panel');
        const toggle  = document.getElementById('nlp-panel-toggle');
        const body    = document.getElementById('nlp-panel-body');
        const insight2 = document.getElementById('nlp-top-insight');
        const chevron = document.getElementById('nlp-chevron');
        if (toggle && body) {
            toggle.addEventListener('click', () => {
                const open = body.style.display !== 'none';
                body.style.display        = open ? 'none' : 'grid';
                if (insight2) insight2.style.display = open ? 'none' : '';
                if (chevron)  chevron.style.transform = open ? 'rotate(-90deg)' : '';
                toggle.setAttribute('aria-expanded', String(!open));
            });
        }
        // Attach event listeners for copy rewrite buttons
        panel?.querySelectorAll('.nlp-copy-rewrite-btn')?.forEach(btn => {
            btn.addEventListener('click', async (e) => {
                e.stopPropagation();
                const text = btn.getAttribute('data-text');
                if (!text) return;
                const ok = await copyToClipboard(text);
                btn.textContent = ok ? 'Copied! ✓' : 'Failed';
                btn.style.background = ok ? '#059669' : '#dc2626';
                setTimeout(() => {
                    btn.textContent = 'Copy';
                    btn.style.background = '#10b981';
                }, 1800);
            });
        });

        if (panel) { panel.classList.add('fade-in-up'); }
    }

    refreshStepIndicators();
});
